import moment from "moment";
import useSushiShopImage from "@src/lib/render-image/hooks/useSushiShopImage";
import { IReorderContentProps } from "./ReorderContent";
import { useCallback, useEffect, useMemo } from "react";
import OrderModel from "@src/backbone/model/OrderModel";
import useBackboneContext from "@src/backbone/provider/useBackboneContext";
import {
  IOrderAccordion,
  IOrderProduct,
} from "design-system/src/Core/OrderAccordion/OrderAccordion";

export const useReorderContentLogic = (props: IReorderContentProps) => {
  const { onClose } = props;
  const { cart, customer } = useBackboneContext();

  const { generateImageUrl } = useSushiShopImage();

  useEffect(() => {
    const handleReorder = () => {
      onClose && onClose();
    };
    cart.on("reorder", handleReorder);
    return () => {
      cart.off("reorder", handleReorder);
    };
  }, [cart, onClose]);

  const handleReorder = useCallback(
    (order: OrderModel) => async () => {
      await cart.reorder(order);
    },
    [cart]
  );

  const list: IOrderAccordion[] = useMemo(() => {
    if (customer) {
      const orders = customer.getLastReorderOrders();
      const orderAccordion: IOrderAccordion[] = [];
      orders.forEach((order) => {
        const date_add = order.get("date_add");
        const total_paid = order.formatTotalPaid();
        const products: IOrderProduct[] =
          order?.getProducts().map<IOrderProduct>((cartProductModel) => {
            const productId = cartProductModel.get("id_product") || "";
            const productModel = cartProductModel.getProduct();
            // const storedProduct = productSelector.selectById(productId);
            const name = productModel?.get("name") || "";
            const picture = productModel?.getPictureByType("rollingstart");
            const image = generateImageUrl({
              id: picture?.id_object_picture || "-1",
            });
            const price: string = productModel?.formatPrice() || "";
            return {
              id: productId,
              image,
              name,
              price,
            };
          }) || [];
        orderAccordion.push({
          id: `${order.id || ""}`,
          formattedDate: date_add
            ? moment(date_add).format("ddd DD MMMM")
            : "-",
          shortFormattedDate: date_add ? moment(date_add).format("DD/MM") : "-",
          totalPrice: total_paid,
          onClick: handleReorder(order),
          formattedQuantity: order.formatQuantity(-1),
          products,
        });
      });
      return orderAccordion;
    }
    return [];
  }, [customer, generateImageUrl, handleReorder]);

  return { list };
};
